export default __webpack_public_path__ + "static/media/triviaquestionscsv.c61fe5cd.csv";